import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { instance } from '../../axios/AxiosInstance';

type ForgotPasswordLocationState = { email?: string };

export default function ForgotPassword() {
  const location = useLocation();
  const prefilledEmail =
    (location.state as ForgotPasswordLocationState | null)?.email?.trim() ?? '';
  const [email, setEmail] = useState(prefilledEmail);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const validateEmail = (email: string) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validate = (): boolean => {
    if (!email) {
      setErrorMsg('Имэйл хаяг оруулна уу');
      return false;
    }
    if (!validateEmail(email)) {
      setErrorMsg('Имэйл хаяг буруу байна');
      return false;
    }
    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    setErrorMsg('');
    setLoading(true);

    instance
      .post('forgot-password', { email })
      .then((res: { status: number; data?: { errorMsg?: string } }) => {
        if (res.status === 200) {
          setSuccessMsg('Имэйл хаяг руу нууц үг сэргээх холбоос илгээлээ. Имэйлээ шалгана уу.');
          setLoading(false);
        } else {
          setErrorMsg(res.data?.errorMsg || 'Алдаа гарлаа');
          setLoading(false);
        }
      })
      .catch((err: { response?: { data?: { message?: string } } }) => {
        console.error(err);
        setErrorMsg(err.response?.data?.message || 'Алдаа гарлаа');
        setLoading(false);
      });
  };

  return (
    <>
      <div className="login-form-heading">
        <h1 className="h1">Нууц үг сэргээх</h1>
      </div>

      <div className="login-form-container">
        {successMsg ? (
          <div className="login-form">
            <div className="form-alert form-alert--success">
              <span className="material-symbols-outlined">mail</span>
              <p className="text-sub">{successMsg}</p>
            </div>
            <Link
              to="/login"
              className="btn-primary login-space-btn"
              style={{ width: '100%', textAlign: 'center', textDecoration: 'none', display: 'block' }}
            >
              Нэвтрэх хуудас руу буцах
            </Link>
          </div>
        ) : (
          <form action="#" className="login-form" onSubmit={handleSubmit}>
            {errorMsg && (
              <div className="form-alert form-alert--error" role="alert">
                <span className="material-symbols-outlined">warning</span>
                <p className="text-sm">{errorMsg}</p>
              </div>
            )}

            <label>
              <span className="label-text login-space-label">Имэйл</span>
              <input
                type="email"
                className="input login-space-input"
                placeholder="name@tomko.mn"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </label>

            <div className="login-submit-wrap">
              <button
                type="submit"
                className="btn-primary login-space-btn"
                style={{ width: '100%' }}
                disabled={loading}
              >
                {loading ? 'Илгээж байна...' : 'Илгээх'}
              </button>
            </div>
          </form>
        )}
      </div>
    </>
  );
}
